import { isRouteErrorResponse, useRouteError } from 'react-router'

/**
 * Keep this free of `@eatout/ui` so the SPA entry chunk does not pull the full
 * UI barrel (and Radix/cmdk) into the initial JS budget.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()

  let title = 'Something went wrong'
  let detail = 'An unexpected error occurred. Try again in a moment.'

  if (isRouteErrorResponse(error)) {
    title = `${String(error.status)} ${error.statusText}`
    detail = typeof error.data === 'string' ? error.data : detail
  } else if (error instanceof Error) {
    detail = error.message
  }

  return (
    <main className="mx-auto mt-16 max-w-lg px-4">
      <section
        role="alert"
        className="rounded-xl border border-destructive/40 bg-destructive/10 p-6 text-destructive"
      >
        <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm text-destructive/90">{detail}</p>
      </section>
    </main>
  )
}
